export default __webpack_public_path__ + "static/fabimage-cd5637a61cbdfbf9c3440e5e1fb10071.svg";